import { IonButton, IonText } from '@ionic/react';
import { Color } from '../common';
import { IIconComponent } from '../icons/Icons';

interface IRoundIconButtonProps{
    'data-id'?: string;
    onClick: ()=>void;
    Icon?: IIconComponent;
    backgroundColor?: Color;
    iconColor?: Color;
    text?: string;
    transparent?: boolean;
    'data-type'?: string;
}

export const RoundIconButton: React.FC<IRoundIconButtonProps> = ({ 'data-id': dataId, onClick, Icon, backgroundColor = 'light', iconColor = 'medium', text, transparent, 'data-type': dataType }) => {
    const buttonSize = 44;
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', width: buttonSize + 10, height: buttonSize + 10 }} onClick={onClick}>
            <IonButton
                color={backgroundColor}
                fill={transparent ? 'outline' : 'solid'}
                data-id={dataId}
                data-type={dataType}
                style={{
                    width: buttonSize,
                    height: buttonSize,
                    '--border-radius': '50%',
                    '--padding-start': 0,
                    '--padding-end': 0,
                }}
            >
                {Icon &&
                    <Icon slot="icon-only" color={iconColor} />
                }
                {text &&
                    <IonText color="medium" style={{fontSize: 13}}><b>{text}</b></IonText>
                }
            </IonButton>
        </div>
    );
};
